import { CalmLogger } from '@calm-web/logger';

export const calmLogger = new CalmLogger(
	process.env.NODE_ENV === 'production'
		? {
				service: 'web-partner-portal',
			}
		: {},
);
